module.exports = __webpack_public_path__ + "img/end-bg-3.baebbbe2.svg";